module.exports = __webpack_public_path__ + "img/zhanghu.a736abf8.jpg";